var encode = encodeURIComponent;

export default function serializeQueryString (params) {
  if (!params) return '';

  return Object.keys(params).sort().map(function (key) {
    var val = params[key];

    if (val === undefined) return '';
    if (val === null) return encode(key);

    if (Array.isArray(val)) {
      var result = [];

      val.forEach(function (v) {
        if (v === undefined) return;

        if (v === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(v));
        }
      });

      return result.join('&');
    }

    return encode(key) + '=' + encode(val);
  }).filter(function (s) {
    return s.length > 0;
  }).join('&');
}



// WEBPACK FOOTER //
// ./utils/serialize-query-string.js